import { ViewMoreButton, UpArrow, DownArrow } from './InternalLinkMod.styles';

export default function ExpandButton({ isExpanded, toggleExpand }) {
  const content = isExpanded
    ? {
        title: 'VIEW LESS',
        Icon: () => <UpArrow />
      }
    : {
        title: 'VIEW MORE',
        Icon: () => <DownArrow />
      };

  return (
    <ViewMoreButton
      data-analytics-id={content.title}
      data-qa="view-more-or-less"
      element="div"
      onClick={toggleExpand}
    >
      {content.title}
      <content.Icon />
    </ViewMoreButton>
  );
}
